import * as OrderStatus from "../constants/order-statuses";

export default {
    methods: {
        getOrderStatusName(status) {
            switch (status.toLowerCase()) {
                case OrderStatus.ORDER_PLACED.toLowerCase():
                    return "Order Placed";
                case OrderStatus.INVOICED.toLowerCase():
                    return "Invoiced";
                case OrderStatus.PICKED_UP.toLowerCase():
                    return "Picked Up";
                case OrderStatus.DESIGNED.toLowerCase():
                    return "Designed";
                case OrderStatus.INTERNAL_PROOF.toLowerCase():
                    return "Designed";
                case OrderStatus.EMAILED_TO_CLIENT.toLowerCase():
                    return "Needs Approval";
                case OrderStatus.PDF_APPROVED.toLowerCase():
                    return "PDF Approved";
                case OrderStatus.READY_FOR_PRINT.toLowerCase():
                    return "Ready for Print";
                case OrderStatus.WALL_POSTERS_PRINTED.toLowerCase():
                    return "Printed";
                case OrderStatus.WALL_POSTERS_SHIPPED.toLowerCase():
                    return "Shipped";
                case OrderStatus.FLATS_PRINTED.toLowerCase():
                    return "Printed";
                case OrderStatus.FLATS_SHIPPED.toLowerCase():
                    return "Shipped";
                case OrderStatus.PREPPED.toLowerCase():
                    return "Printing";
                case OrderStatus.CLOSED.toLowerCase():
                    return "Closed";
                default:
                    if (status) {
                        return status[0].toUpperCase() + status.slice(1);
                    }
            }
        },
        getOrderStatusFullName(status) {
            switch (status.toLowerCase()) {
                case OrderStatus.ORDER_PLACED.toLowerCase():
                    return "Order Placed";
                case OrderStatus.INVOICED.toLowerCase():
                    return "Invoiced";
                case OrderStatus.PICKED_UP.toLowerCase():
                    return "Picked Up";
                case OrderStatus.DESIGNED.toLowerCase():
                    return "Designed";
                case OrderStatus.INTERNAL_PROOF.toLowerCase():
                    return "Proofed";
                case OrderStatus.EMAILED_TO_CLIENT.toLowerCase():
                    return "Emailed to Client";
                case OrderStatus.NEEDS_APPROVAL.toLowerCase():
                    return "Needs Approval";
                case OrderStatus.PDF_APPROVED.toLowerCase():
                    return "PDF Approved";
                case OrderStatus.READY_FOR_PRINT.toLowerCase():
                    return "Ready for Print";
                case OrderStatus.WALL_POSTERS_PRINTED.toLowerCase():
                    return "Wall Posters Printed";
                case OrderStatus.WALL_POSTERS_SHIPPED.toLowerCase():
                    return "Wall Posters Shipped";
                case OrderStatus.FLATS_PRINTED.toLowerCase():
                    return "Flats Printed";
                case OrderStatus.FLATS_SHIPPED.toLowerCase():
                    return "Flats Shipped";
                case OrderStatus.PREPPED.toLowerCase():
                    return "Prepped";
                case OrderStatus.CLOSED.toLowerCase():
                    return "Closed";
                default:
                    if (status) {
                        return status[0].toUpperCase() + status.slice(1);
                    }
            }
        },
    },
};
